import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";
import type { ReactNode } from "react";

interface Props {
  /** Position and size, e.g. `{ right: 16, top: 16, minWidth: 220 }`. */
  sx: SxProps<Theme>;
  children: ReactNode;
}

/** A translucent info box floating above the map; clicks pass through to the map. */
export function MapOverlayBox({ sx, children }: Props) {
  return (
    <Box
      sx={[
        {
          position: "absolute",
          zIndex: 1200,
          pointerEvents: "none",
          bgcolor: "rgba(255,255,255,0.98)",
          border: "1px solid rgba(0,0,0,0.15)",
          borderRadius: 1,
          px: 1.5,
          py: 1,
          boxShadow: 3,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
}
